import Icon from '../components/Icon.vue'

Icon.register({
  'caret-square-up': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 432v-352c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48zM355.5 291.5l-123-123c-4.7-4.7-12.3-4.7-17 0l-123 123c-7.6 7.6-2.2 20.5 8.5 20.5h246.1c10.7 0 16-12.9 8.5-20.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/caret-square-up.js
// module id = 1156
// module chunks = 0